import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=e243c312&scoped=true"
var script = {}
import style0 from "./Specification.vue?vue&type=style&index=0&id=e243c312&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e243c312",
  null
  
)

export default component.exports